import { createSelector } from '@reduxjs/toolkit';

import { getImmutableCompatible } from 'src/utils/immutableUtils';

import { name } from './slice';
import type { HotelImagesState } from './types';

const hotelsImagesState = (state): HotelImagesState =>
  getImmutableCompatible(state, name);

export const hotelImagesByIdSelector = createSelector(
  [hotelsImagesState, (_, id: number) => id],
  (images, id) => (id ? images[id] : []),
);
